import config from '../config';

export const FB_PIXEL_ID = config.pixelId;

export const pageview = () => {
    window.fbq('track', 'PageView');
};

export const event = (name, options = {}) => {
    window.fbq('track', name, options);
};

export const customEvent = (name, options = {}) => {
    window.fbq('trackCustom', name, options);
};
